'use client'
import { cx } from '../utils'

export function Separator({ className }: { className?: string }) {
  return <hr className={cx('border-t border-line', className)} />
}
